import { Typography } from "@material-tailwind/react";
import FAQComponent from "./FAQComponent";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

function TGAFAQsComponent() {
  const { t } = useTranslation();
  const faqs = [
    {
      id: "1",
      question: t("WhatIsTGAConcept"),
      answer: t("WhatIsTGAConceptAnswer"),
    },
    {
      id: "2",
      question: t("HowDoICreateAnAccountAndLicense"),
      answer: t("HowDoICreateAnAccountAndLicenseAnswer"),
    },
    {
      id: "3",
      question: t("WhatAreTemplatesInTGAConcept"),
      answer: t("WhatAreTemplatesInTGAConceptAnswer"),
    },
    {
      id: "4",
      question: t("HowDoIDefineRoomsInTGAConcept"),
      answer: t("HowDoIDefineRoomsInTGAConceptAnswer"),
    },
  ];

  // Generate FAQ structured data
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <div className="bg-#F6F6F6 pb-[50px]">
        <Typography className="uppercase text-lg 2xl:text-3xl font-bold tracking-[0.9px] text-center py-[30px] lg:py-[60px]">
          {t("FAQ")}
        </Typography>
        <div className="mx-[20px] lg:mx-[100px] flex flex-col gap-[15px]">
          {faqs.map((faq) => (
            <FAQComponent key={faq.id} faq={faq} />
          ))}
        </div>
      </div>
    </>
  );
}

export default TGAFAQsComponent;
